import React, {useRef, useCallback} from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import ReactGA from 'react-ga';

import {textMap} from "../common/Localization";

import './Price.scss';

const Price = () => {

	const id = useSelector(state => state.ScrollModule.id);

	const showPrice = useRef();

	if(!showPrice.current && id === "price") {
		showPrice.current = true;
	}

	const sendGa1 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"가격-Basic"
		});
	}, []);
	const sendGa2 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-문의",
			label:"가격-Standard"
		});
	}, []);
	const sendGa3 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-문의",
			label:"가격-Premium"
		});
	}, []);

	return (
		<div id="price" className="view_section">
			<div className="price_wrap">
				<div className={classNames("title", "c_03")}>{textMap.formatString(textMap.price_title, <span className="c_blue">{textMap.price_title_2}</span>)}</div>
				<div className={classNames("description", "c_5b")}>{textMap.price_desc}</div>
				<div className="price_list_wrap">
					<div className={classNames("price_item", "sc_box", "cbc_f8", showPrice.current ? "show" : "")}>
						<div className={classNames("price_header", "lc_e2")}>
							<span className={classNames("price_badge", "cbc_light_blue", "c_blue")}>{textMap.price_tier_title_1}</span>
							<div className={classNames("old_price", "c_95")}>{textMap.price_tier_old_price_1}</div>
							<div className={classNames("tier_price", "c_28")}>{textMap.price_tier_price_1}<span className={classNames("tier_price_info", "c_69")}>{textMap.price_tier_price_info_1}</span></div>
							<img className="tier_image" src={process.env.PUBLIC_URL + "/icon/price_tier_1.png"} alt=""/>
						</div>
						<div className={classNames("price_body")}>
							<div className={classNames("tier_desc", "c_3b")}>{textMap.price_tier_desc_1}</div>
							<div className="tier_check_wrap">
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_1}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_6}</div>
								{/* <div className={classNames("check_item", "c_red", "check_bold")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check_red.png"} alt=""/>{textMap.price_tier_check_7}</div>
								<div className={classNames("check_item_help", "c_red")}>{textMap.price_tier_check_8}</div> */}
							</div>
						</div>
						<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa1}>
							<div className={classNames("tier_button", "c_ff", "cbc_blue", "sc_blue")}>{textMap.price_tier_button}</div>
						</a>
						<div className={classNames("tier_badge", "c_ff", "cbc_blue")}>{textMap.price_tier_badge}</div>
					</div>
					<div className={classNames("price_item", "sc_box", "cbc_f8", showPrice.current ? "show" : "")}>
						<div className={classNames("price_header", "lc_e2")}>
							<span className={classNames("price_badge", "cbc_light_blue", "c_blue")}>{textMap.price_tier_title_2}</span>
							<div className={classNames("tier_price", "c_28")}>{textMap.price_tier_price_2}</div>
							<img className="tier_image" src={process.env.PUBLIC_URL + "/icon/price_tier_2.png"} alt=""/>
						</div>
						<div className={classNames("price_body")}>
							<div className={classNames("tier_desc", "c_3b")}>{textMap.price_tier_desc_2}</div>
							<div className="tier_check_wrap">
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_1}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_2}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_3}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_6}</div>
								{/* <div className={classNames("check_item", "c_red", "check_bold")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check_red.png"} alt=""/>{textMap.price_tier_check_7}</div>
								<div className={classNames("check_item_help", "c_red")}>{textMap.price_tier_check_8}</div> */}
							</div>
						</div>
						<a href="https://minimap.typeform.com/to/o9H3gCwI" target="_blank" rel="noopener noreferrer" onClick={sendGa2}>
							<div className={classNames("tier_button", "c_ff", "cbc_blue", "sc_blue")}>{textMap.price_tier_button_2}</div>
						</a>
					</div>
					<div className={classNames("price_item", "sc_box", "cbc_f8", showPrice.current ? "show" : "")}>
						<div className={classNames("price_header", "lc_e2")}>
							<span className={classNames("price_badge", "cbc_light_blue", "c_blue")}>{textMap.price_tier_title_3}</span>
							<div className={classNames("tier_price", "c_28")}>{textMap.price_tier_price_3}</div>
							<img className="tier_image" src={process.env.PUBLIC_URL + "/icon/price_tier_3.png"} alt=""/>
						</div>
						<div className={classNames("price_body")}>
							<div className={classNames("tier_desc", "c_3b")}>{textMap.price_tier_desc_3}</div>
							<div className="tier_check_wrap">
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_1}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_2}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_3}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_4}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_5}</div>
								<div className={classNames("check_item", "c_69")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check.png"} alt=""/>{textMap.price_tier_check_6}</div>
								{/* <div className={classNames("check_item", "c_red", "check_bold")}><img className="check_icon" src={process.env.PUBLIC_URL + "/icon/check_red.png"} alt=""/>{textMap.price_tier_check_7}</div>
								<div className={classNames("check_item_help", "c_red")}>{textMap.price_tier_check_8}</div> */}
							</div>
						</div>
						<a href="https://minimap.typeform.com/to/o9H3gCwI" target="_blank" rel="noopener noreferrer" onClick={sendGa3}>
							<div className={classNames("tier_button", "c_ff", "cbc_blue", "sc_blue")}>{textMap.price_tier_button_2}</div>
						</a>
					</div>
				
				</div>
			</div>
		</div>
	);
};

export default Price;
